/* global jQuery */
const moment = require('moment');

angular.module('app.coupons', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging'])
.config(['$routeProvider', function ($routeProvider) {
  $routeProvider.when('/coupons', {
    template: require('./coupons.html'),
    controller: 'couponsCtrl',
  }).when('/coupons/add', {
    template: require('./add.html'),
    controller: 'couponsAddCtrl',
  });
}])
.controller('couponsCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $window, AuthService, envService) => {
  $rootScope.mainmenu = 'coupons';
  $rootScope.menu = 'wash';
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  $scope.total_count = 0;
  $scope.query = '';
  $resource(`${APIURL}/admin/coupons`).get({ q: $scope.query }, (data) => {
    $scope.coupons = data.coupons;
    $scope.total_count = data.total_count;
  }, (err) => {
    console.error(err);
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });

  $scope.paging = (page) => {
    $resource(`${APIURL}/admin/coupons`).get({ page: page - 1, q: $scope.query },
      (data) => {
        $scope.coupons = data.coupons;
        $scope.total_count = data.total_count;
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };

  $scope.delete = (coupon) => {
    const isGroup = coupon.COUPON_COUNT && coupon.COUPON_COUNT > 1;
    const couponId = isGroup ? coupon.GROUP_ID : coupon.ID;
    if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
      return;
    }
    $resource(`${APIURL}/admin/coupons/${couponId}`).delete({ isGroup },
        () => {
          alert($translate.instant('삭제되었습니다'));
          $scope.coupons.splice($scope.coupons.indexOf(coupon), 1);
          jQuery('#modal-coupon').removeClass('fade');
          jQuery('#modal-coupon').modal('hide');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
  };

  $scope.showGroupCoupons = (coupon) => {
    $scope.group_coupon_id = coupon.GROUP_ID;
    $scope.group_coupons_download_url = `${APIURL}/admin/coupons/group/${$scope.locale}/${coupon.GROUP_ID}.csv`;
    $resource(`${APIURL}/admin/coupons/group/${coupon.GROUP_ID}`).get((data) => {
      $scope.group_coupons = data.coupons;
      $scope.group_coupons_total_count = data.total_count;
      jQuery('#modal-coupon').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.pagingGroupCoupons = (page) => {
    $resource(`${APIURL}/admin/coupons/group/${$scope.group_coupon_id}`).get({ page: page - 1 }, (data) => {
      $scope.group_coupons = data.coupons;
      $scope.group_coupons_total_count = data.total_count;
    }, (err) => {
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
})
.controller('couponsAddCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $window, $timeout, AuthService, envService) => {
  $rootScope.mainmenu = 'coupons';
  $rootScope.menu = 'wash';
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  let _searchTimeout;
  $scope.newcoupon = { STARTDATE: `${moment().format('YYYY/MM/DD')}`,
    ENDDATE: `${moment().add(30, 'days').format('YYYY/MM/DD')}`,
    PRICE: 50000,
    COUNT: 1,
    MESSAGE: '',
    MESSAGE_TYPE: '0',
    NOTE: '',
    CODE_PREFIX: '' };
  $scope.selectedUsers = [];

  $scope.submit = () => {
    if (!moment($scope.newcoupon.STARTDATE, 'YYYY/MM/DD', true).isValid()) {
      alert($translate.instant('올바른 유효기간:시작일을 입력해주세요.(예:2016/01/01)'));
      return;
    }
    if (!moment($scope.newcoupon.ENDDATE, 'YYYY/MM/DD', true).isValid()) {
      alert($translate.instant('올바른 유효기간:만료일을 입력해주세요.(예:2016/01/01)'));
      return;
    }
    if (!moment($scope.newcoupon.ENDDATE, 'YYYY/MM/DD', true).isAfter(moment($scope.newcoupon.STARTDATE, 'YYYY/MM/DD', true))) {
      alert($translate.instant('만료일은 시작일 보다 커야 합니다.'));
      return;
    }
    if ($scope.newcoupon.PRICE === undefined) {
      alert($translate.instant('가격을 입력해주세요.'));
      return;
    }
    if (isNaN(parseInt($scope.newcoupon.PRICE, 10))) {
      alert($translate.instant('올바른 가격을 입력해주세요.'));
      return;
    }
    if ($scope.newcoupon.MESSAGE_TYPE == '0') { //eslint-disable-line
      $scope.newcoupon.MESSAGE = '고객님께 할인쿠폰이 발급 되었습니다.';
    } else if ($scope.newcoupon.MESSAGE_TYPE == '1') { //eslint-disable-line
      $scope.newcoupon.MESSAGE = '고객님께 결빙취소쿠폰이 발급 되었습니다.';
    } else if ($scope.newcoupon.MESSAGE_TYPE == '2') { //eslint-disable-line
      $scope.newcoupon.MESSAGE = '고객님께 우천취소쿠폰이 발급 되었습니다.';
    }
    if ($scope.newcoupon.MESSAGE_TYPE == '3' && $scope.newcoupon.MESSAGE.length < 1) { //eslint-disable-line
      alert($translate.instant('메세지를 입력해주세요.'));
      return;
    }
    if ($scope.newcoupon.NOTE.length < 1) {
      alert($translate.instant('발급사유를 입력해주세요.'));
      return;
    }
    $scope.newcoupon.TB_USER_ID = [];
    for (let idx = 0; idx < $scope.selectedUsers.length; idx += 1) {
      $scope.newcoupon.TB_USER_ID.push($scope.selectedUsers[idx].ID);
    }

    $scope.newcoupon.DESCRIPTION = $translate.instant('오프라인');
    if ($scope.selectedUsers.length > 0) {
      $scope.newcoupon.QUANTITY_PER_CODE = 1;
      $scope.newcoupon.CODE_PREFIX = '';
      $scope.newcoupon.COUPON_VALID_DAYS = undefined;

      $scope.newcoupon.DESCRIPTION = `${$scope.selectedUsers[0].NAME}(${$scope.selectedUsers[0].TEL}/${$scope.selectedUsers[0].ADDR})`;
      if ($scope.selectedUsers.length > 2) {
        $scope.newcoupon.DESCRIPTION = `${$scope.newcoupon.DESCRIPTION}외 ${$scope.selectedUsers.length - 1}명`;
      }
    } else {
      $scope.newcoupon.MESSAGE = '';
    }
   
    $resource(`${APIURL}/admin/coupons`).save($scope.newcoupon, () => {
      alert($translate.instant('쿠폰이 발급되었습니다.'));
      $location.path('/coupons');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  // 사용자 검색
  $scope.openUsers = () => {
    $scope.userSearch = { query: '', result: [] };
    jQuery('#modal-user').modal('show');
  };
  $scope.searchUsers = () => {
    if (_searchTimeout) { // if there is already a timeout in process cancel it
      $timeout.cancel(_searchTimeout);
    }
    _searchTimeout = $timeout(() => {
      $resource(`${APIURL}/admin/users`).get({ q: $scope.userSearch.query, count: -1 }, (data) => {
        $scope.userSearch.result = data.users;
        console.log(data);
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    }, 500);
  };
  $scope.selectUser = (user) => {
    for (let idx = 0; idx < $scope.selectedUsers.length; idx += 1) {
      const testUser = $scope.selectedUsers[idx];
      if (testUser.ID === user.ID) {
        $scope.selectedUsers.splice(idx, 1);
        return;
      }
    }
    $scope.selectedUsers.push(user);
  };
  $scope.isUserSelected = (user) => {
    for (let idx = 0; idx < $scope.selectedUsers.length; idx += 1) {
      const testUser = $scope.selectedUsers[idx];
      if (testUser.ID === user.ID) {
        return true;
      }
    }
    return false;
  };
  $scope.hideUsers = () => {
    jQuery('#modal-user').modal('hide');
  };
});



// WEBPACK FOOTER //
// ./src/app/coupons/coupons.js